// extracted by mini-css-extract-plugin
export default {"wrapper":"UBw4SLBjVawn3nHPrcPk","content":"K6vBdobIvXAhKHwcloh9","dataRow":"fqBEc3vmsqjJfd6YslPZ"};